import update from 'immutability-helper'
import { AnyAction } from 'redux'
import { IBillingSettings } from '@app/@types/myEnergy'
import * as type from '@app/constants/myEnergy/setUpBillingPeriod'

export interface ISetUpBillingPeriodState {
  billingSettings: IBillingSettings,
}

const initialState: ISetUpBillingPeriodState = {
  billingSettings: {
    cost_of_kwh: '',
    payment_day: '',
  },
}

export default function setUpBillingPeriod(
  state: ISetUpBillingPeriodState = initialState,
  action: AnyAction,
): ISetUpBillingPeriodState {
  switch (action.type) {
  case type.UPDATE_BILLING_SETTINGS:
    return update(state, {
      billingSettings: { $set: action.settings },
    })
  case type.RESET_SET_UP_BILLING_PERIOD_OPTIONS:
    return initialState
  default:
    return state
  }
}
